export default "__VITE_ASSET__f6fdaccf__"